import React from "react";
import { Link } from "react-router-dom";
import Rightimage from "../assets/images/Aboutus-img.svg";
import Leftimage from "../assets/images/Left-img.svg";
import Clients from "./Clients";

const CelebrationDetailLanding: React.FC = () => {
  return (
    <section className="relative bg-white text-gray-800 py-16">
      <div className="absolute right-0 top-2 sm:top-0 w-16 sm:w-auto">
        <img src={Rightimage} alt="Seamless Travel" className="object-fill" />
      </div>

      <div className="max-w-4xl mx-auto px-6 space-y-14">
        <section>
        
          <p className="text-lg leading-relaxed text-gray-700 font-poppins">
            Destination weddings, honeymoons, or milestone getaways sound like a
            dream… until you're juggling RSVPs, vendor calls, guest logistics,
            and flight anxiety. One delay and the whole event can unravel.
          </p>
        </section>
    

        <section>
          <h2 className="text-2xl font-semibold text-blue-800 mb-3 font-akshar">
            The Vision
          </h2>
          <p className="text-lg leading-relaxed text-gray-700 font-poppins">
            Now imagine this: vows exchanged on a cliffside in Santorini.
            Champagne under a Bali sunset. Your favorite people dancing under
            the stars in a private villa in Tuscany. Every detail flawless.
            Every moment unforgettable.
          </p>
        </section>
      </div>
      <div className="absolute left-0 bottom-2 sm:bottom-0 w-16 sm:w-36">
        <img src={Leftimage} alt="Seamless Travel" className="object-fill" />
      </div>
    </section>
  );
};

export default CelebrationDetailLanding;
